import React, { createRef, useRef } from 'react';
import graphql from 'graphql';
import PropTypes from 'prop-types';
import { kebabCase } from 'lodash';
import Helmet from 'react-helmet';
import Link from 'gatsby-link';
import Content, { HTMLContent, StripMarkdown } from '../components/Content';
import VimeoBackgroundCover from '../components/VimeoBackgroundCover.js';
// import Plyr from 'react-plyr';
// import 'plyr/dist/plyr.css';
import Plyr from 'plyr-react';
import 'plyr-react/dist/plyr.css';
import { parseVimeoUrl } from '../utils/vimeo';
import moment from 'moment';
// import screenfull from 'screenfull';
import { scroller } from 'react-scroll';
import { isMobile } from 'react-device-detect';
import Vimeo from '../components/Vimeo';

import VolumeOnSvg from '../img/volume-on.svg';
import VolumeOffSvg from '../img/volume-off.svg';
import StopSvg from '../img/stop.svg';

import { url as siteUrl } from '../../site.json';

// export const ProjectPostTemplate2 = ({
//   content,
//   contentComponent,
//   tags,
//   title,
//   helmet,
//   image,
//   videoUrl,
//   credits,
// }) => {
//   const videoRef = useRef()
//   const [videoPercentage, setVideoPercentage] = useState(100)
//   const [duration, setDuration] = useState(0)
//   const [seconds, setSeconds] = useState(0)
//   const [mounted, setMounted] = useState(0)
//   const { videoPercentage, duration, seconds, mounted } = this.state;

//   const PostContent = contentComponent || Content
//   const { id: videoId } = getVideoId(videoUrl);

//   let player = <Plyr
//     ref={videoRef}
//     type="vimeo"
//     videoId={videoId}
//     autoplay
//     hideControls={false}
//     controls={['progress']}
//     // onReady={(plyr) => {
//     //   this.plyr = plyr;
//     //   this.plyr.setVolume(100);
//     //   this._setupListeners();
//     // }}
//   />

//   if (isMobile) {
//     player = (
//       <div className="b-video-container-169">
//         <Vimeo
//           id={videoId}
//           vimeoOptions={{ byline: false, portrait: false, title: false }}
//           className="b-video-container-make-height" />
//       </div>
//     )
//   }
//   return (
//     <div>
//       {helmet || ''}
//       <div className="b-video-container m-project" style={{ maxHeight: '100vh', position: 'relative' }}>
//         { mounted ? player : null }
//         <div className="b-abs m-btm-pad m-left-pad is-hidden-touch">
//           <img
//             // onClick={() => {
//             //   if (this.plyr) {
//             //     this.plyr.togglePlay();
//             //   }
//             // }}
//             src={StopSvg}
//             className="svg-fullscreen-icon is-inline is-pulled-left is-unselectable"
//           />
//           <div className="is-pulled-left m-text-red is-size-5 is-size-6-touch has-text-weight-semibold"
//             style={{ lineHeight: '4rem', marginLeft: '2rem' }} >
//             {moment().startOf('day').seconds(seconds).format('H:mm:ss')} / {moment().startOf('day').seconds(duration).format('H:mm:ss')}
//           </div>
//         </div>
//         <div className="b-abs m-btm-pad m-right-pad is-hidden-touch">
//           <img
//             onClick={() => this.toggleVolume()}
//             src={this.state.muted ? VolumeOffSvg : VolumeOnSvg}
//             className="svg-fullscreen-icon is-inline is-unselectable" style={{ marginRight: '2rem' }}
//           />
//           <svg onClick={() => {
//             if (screenfull.enabled) {
//               screenfull.toggle();
//             } else {
//               // this.plyr.toggleFullscreen();
//             }
//           }} viewBox="0 0 100 100" className="svg-fullscreen-icon is-inline is-unselectable">
//             <line x1="0" y1="0"
//                   x2="0" y2="40"
//             />
//             <line x1="0" y1="60"
//                   x2="0" y2="100"
//             />
//             <line x1="0" y1="0"
//                   x2="40" y2="0"
//             />
//             <line x1="60" y1="0"
//                   x2="100" y2="0"
//             />
//             <line x1="100" y1="0"
//                   x2="100" y2="40"
//             />
//             <line x1="100" y1="60"
//                   x2="100" y2="100"
//             />
//             <line x1="0" y1="100"
//                   x2="40" y2="100"
//             />
//             <line x1="60" y1="100"
//                   x2="100" y2="100"
//             />
//           </svg>
//         </div>
//       </div>

//       <div className="top-right" style={{ zIndex: 10 }}>
//         <Link to={{
//           pathname: `/`,
//           state: { transition: 'fade', scrollTo: kebabCase(title), scrollOffset: -50 }
//         }}>
//           <svg viewBox="0 0 100 100" className="svg-close-icon is-unselectable">
//             <line x1="0" y1="100"
//                   x2="100" y2="0"
//             />
//             <line x1="0" y1="0"
//                   x2="100" y2="100"
//             />
//           </svg>
//         </Link>
//       </div>

//       <section name="description" className="section m-text-white m-collapse" style={{ zIndex: 0 }}>
//         <div className="container is-fluid">
//           <div className="columns is-gapless">
//             <div className="column" >
//               <h1 className="home-title is-size-2 is-size-4-touch has-text-weight-bold is-bold-light">
//                 {title}
//               </h1>
//               {tags && tags.length ? (
//                 <div style={{ margin: `2rem 0` }}>
//                   <ul className="taglist is-size-6-touch is-capitalized">
//                     {tags.map(tag => (
//                       <li key={tag + `tag`}>
//                         {/* <Link to={`/tags/${kebabCase(tag)}/`}> */}
//                           {tag}
//                         {/* </Link> */}
//                       </li>
//                     ))}
//                   </ul>
//                 </div>
//               ) : null}
//             </div>
//           </div>
//           <div className="columns">
//             <div className="column" >
//               <PostContent className="is-size-5" content={content} />
//             </div>
//             <div className="column" >
//               <PostContent className="is-size-5" content={credits} />
//             </div>
//           </div>
//         </div>
//       </section>
//     </div>
//   )
// }
export class ProjectPostTemplate extends React.Component {

  static propTypes = {
    content: PropTypes.string.isRequired,
    contentComponent: PropTypes.func,
    title: PropTypes.string,
    helmet: PropTypes.object,
  }

  state = {
    videoPercentage: 100,
    duration: 0,
    seconds: 0,
    muted: false,
    mounted: false,
  }

  constructor(props) {
    super(props)
    this.plyr = createRef()
  }

  _onProgress = (event) => {
    const duration = this.plyr.current.plyr.duration;
    const seconds = this.plyr.current.plyr.currentTime;
    const percent = seconds && duration ? seconds / duration : 0;
    console.log('onP', { duration, seconds, percent })
    this.setState({
      videoPercentage: percent * 100,
      duration,
      seconds,
    });
  }

  _setupListeners = () => {
    if (this.plyr.current) {
      // this.plyr.current.plyr.on('timeupdate', this._onProgress);
      // this.plyr.current.plyr.play();
    }
  }

  toggleVolume = () => {
    if (this.plyr.current.plyr) {
      const volume = this.plyr.current.plyr.volume;
      this.plyr.current.plyr.volume = volume > 0 ? 0 : 1;
      this.setState({ muted: volume > 0 });
    }
  }

  componentDidMount() {
    this.setState({ mounted: true });
    setTimeout(this._setupListeners, 1000);
  }

  render() {
    const {
      content,
      contentComponent,
      tags,
      title,
      helmet,
      image,
      videoUrl,
      credits,
    } = this.props;

    const { duration, seconds, mounted } = this.state;

    const PostContent = contentComponent || Content
    const { id: videoId, hash: videoHash, url: videoCanonicalUrl } = parseVimeoUrl(videoUrl);

    let player = null

    if (isMobile) {
      player = (
        <div className="b-video-container-169">
          <Vimeo
            url={videoCanonicalUrl}
            autoPlay
            muted
            vimeoOptions={{ autoplay: true, muted: true, byline: false, portrait: false, title: false }}
            className="b-video-container-make-height" />
        </div>
      )
    } else {
      player = (
        <Plyr
          ref={(player) => (this.plyr.current = player)}
          source={{
            type: 'video',
            sources: [
              {
                src: videoId,
                provider: 'vimeo',
              },
            ]
          }}
          options={{
            autoplay: true,
            // muted: true,
            // hideControls: true,
            controls: ['current-time'],
            ratio: '16:9',
            // Unlisted Vimeo videos need their privacy hash as ?h= on the embed
            vimeo: videoHash ? { h: videoHash } : {},
          }}
        />
      )
    }

    return (
      <div>
        {helmet || ''}
        <div className="b-video-container m-project" style={{ maxHeight: '100vh', position: 'relative' }}>
          { mounted ? player : null }
          <div className="b-abs m-btm-pad m-left-pad is-hidden-touch">
            <img
              onClick={() => {
                if (this.plyr.current.plyr) {
                  this.plyr.current.plyr.togglePlay();
                }
              }}
              src={StopSvg}
              className="svg-fullscreen-icon is-inline is-pulled-left is-unselectable"
            />
            <div className="is-pulled-left m-text-red is-size-5 is-size-6-touch has-text-weight-semibold"
              style={{ lineHeight: '4rem', marginLeft: '2rem' }} >
              {moment().startOf('day').seconds(seconds).format('H:mm:ss')} / {moment().startOf('day').seconds(duration).format('H:mm:ss')}
            </div>
          </div>
          <div className="b-abs m-btm-pad m-right-pad is-hidden-touch">
            <img
              onClick={() => this.toggleVolume()}
              src={this.state.muted ? VolumeOffSvg : VolumeOnSvg}
              className="svg-fullscreen-icon is-inline is-unselectable" style={{ marginRight: '2rem' }}
            />
            <svg onClick={() => {
              // if (screenfull.enabled) {
              //   screenfull.toggle();
              // } else {
                this.plyr.current.plyr.fullscreen.toggle();
              // }
            }} viewBox="0 0 100 100" className="svg-fullscreen-icon is-inline is-unselectable">
              <line x1="0" y1="0"
                    x2="0" y2="40"
              />
              <line x1="0" y1="60"
                    x2="0" y2="100"
              />
              <line x1="0" y1="0"
                    x2="40" y2="0"
              />
              <line x1="60" y1="0"
                    x2="100" y2="0"
              />
              <line x1="100" y1="0"
                    x2="100" y2="40"
              />
              <line x1="100" y1="60"
                    x2="100" y2="100"
              />
              <line x1="0" y1="100"
                    x2="40" y2="100"
              />
              <line x1="60" y1="100"
                    x2="100" y2="100"
              />
            </svg>
          </div>
        </div>

        <div className="top-right" style={{ zIndex: 10 }}>
          <Link to={{
            pathname: `/`,
            state: { transition: 'fade', scrollTo: kebabCase(title), scrollOffset: -50 }
          }}>
            <svg viewBox="0 0 100 100" className="svg-close-icon is-unselectable">
              <line x1="0" y1="100"
                    x2="100" y2="0"
              />
              <line x1="0" y1="0"
                    x2="100" y2="100"
              />
            </svg>
          </Link>
        </div>

        <section name="description" className="section m-text-white m-collapse" style={{ zIndex: 0 }}>
          <div className="container is-fluid">
            <div className="columns is-gapless">
              <div className="column" >
                <h1 className="home-title is-size-2 is-size-4-touch has-text-weight-bold is-bold-light">
                  {title}
                </h1>
                {tags && tags.length ? (
                  <div style={{ margin: `2rem 0` }}>
                    <ul className="taglist is-size-6-touch is-capitalized">
                      {tags.map(tag => (
                        <li key={tag + `tag`}>
                          {/* <Link to={`/tags/${kebabCase(tag)}/`}> */}
                            {tag}
                          {/* </Link> */}
                        </li>
                      ))}
                    </ul>
                  </div>
                ) : null}
              </div>
            </div>
            <div className="columns">
              <div className="column" >
                <PostContent className="is-size-5" content={content} />
              </div>
              <div className="column" >
                <PostContent className="is-size-5" content={credits} />
              </div>
            </div>
          </div>
        </section>
      </div>
    )
  }
}

const ProjectPost = ({ data }) => {
  const { markdownRemark: post } = data;

  return (
    <ProjectPostTemplate
      content={post.html}
      contentComponent={Content}
      helmet={
        <Helmet>
          <title>{post.frontmatter.title} | Project</title>
          <meta name="description" content={post.excerpt} />
          <meta property="og:title" content={post.frontmatter.title} />
          <meta property="og:type" content="video.other" />
          <meta property="og:url" content={`${siteUrl}/projects/${kebabCase(post.frontmatter.title)}`} />
          <meta property="og:image" content={siteUrl + post.frontmatter.image} />
          <meta property="og:description" content={post.excerpt} />
        </Helmet>
      }
      tags={post.tags}
      title={post.frontmatter.title}
      image={post.frontmatter.image}
      credits={post.frontmatter.credits}
      videoUrl={post.frontmatter.videoUrl}
    />
  )
}

ProjectPost.propTypes = {
  data: PropTypes.shape({
    markdownRemark: PropTypes.object,
  }),
}

export default ProjectPost

export const pageQuery = graphql`
  query ProjectPostByID($id: String!) {
    markdownRemark(id: { eq: $id }) {
      id
      html
      excerpt
      tags
      frontmatter {
        date(formatString: "MMMM DD, YYYY")
        title
        videoUrl
        image
        credits
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/project-post.js